import { SUBJECTS_THEME } from '../theme';

/**
 * Admin-only navigation — dashboard + course dropdown + ops panels.
 */
export function getAdminNavItems(activeKey = 'dashboard') {
  const subjectIds = new Set(SUBJECTS_THEME.map((s) => s.id));
  const courseActive = subjectIds.has(activeKey);

  return [
    {
      key: 'dashboard',
      icon: 'dashboard',
      label: 'Dashboard',
      path: '/admin?tab=dashboard',
      active: activeKey === 'dashboard' || activeKey === 'home',
    },
    {
      key: 'course',
      icon: 'auto_stories',
      label: 'Course Content',
      defaultExpanded: courseActive,
      children: SUBJECTS_THEME.map((s) => ({
        key: s.id,
        icon: s.icon,
        label: s.label,
        path: `/admin?tab=${s.id}`,
        active: activeKey === s.id,
        color: s.color,
      })),
    },
    {
      key: 'exam-docs',
      icon: 'quiz',
      label: 'Question bank',
      path: '/admin?tab=exam-docs',
      active: activeKey === 'exam-docs',
    },
    {
      key: 'inquiries',
      icon: 'contact_mail',
      label: 'Inquiries',
      path: '/admin?tab=inquiries',
      active: activeKey === 'inquiries',
    },
    {
      key: 'unpaid-enrollments',
      icon: 'money_off',
      label: 'Enrolled but not paid',
      path: '/admin?tab=unpaid-enrollments',
      active: activeKey === 'unpaid-enrollments',
    },
    {
      key: 'subscriptions',
      icon: 'card_membership',
      label: 'Subscriptions',
      path: '/admin?tab=subscriptions',
      active: activeKey === 'subscriptions',
    },
    {
      key: 'payments',
      icon: 'receipt_long',
      label: 'Payments',
      path: '/admin?tab=payments',
      active: activeKey === 'payments',
    },
    {
      key: 'pricing',
      icon: 'payments',
      label: 'Fee Structure',
      path: '/admin?tab=pricing',
      active: activeKey === 'pricing',
    },
    {
      key: 'student-progress',
      icon: 'monitoring',
      label: 'Progress',
      path: '/admin?tab=student-progress',
      active: activeKey === 'student-progress',
    },
    {
      key: 'messages',
      icon: 'forum',
      label: 'Messages',
      path: '/admin?tab=messages',
      active: activeKey === 'messages',
    },
  ];
}

export function getAdminPageMeta(activeKey) {
  const map = {
    dashboard: {
      title: 'Admin Dashboard',
      subtitle: 'Overview of inquiries, enrollments, payments, and course content',
    },
    'exam-docs': {
      title: 'Question bank',
      subtitle: 'Upload questions and set titled, timed exams for each subject',
    },
    inquiries: {
      title: 'Registration Inquiries',
      subtitle: 'Contact form submissions — grant access and enroll students',
    },
    'unpaid-enrollments': {
      title: 'Enrolled but not paid',
      subtitle: 'Website signups that have not completed card or cash payment',
    },
    subscriptions: {
      title: 'Subscriptions',
      subtitle: 'Student accounts, registration numbers, and access plans',
    },
    payments: {
      title: 'Payments',
      subtitle: 'All student payments with search, filters, and exports',
    },
    pricing: {
      title: 'Fee Structure',
      subtitle: 'Study plans, exam fees, degree charges, and website contact info',
    },
    'student-progress': {
      title: 'Student Progress',
      subtitle: 'Study time, lecture and module quiz monitor, and AI reports',
    },
    messages: {
      title: 'Messages',
      subtitle: 'Conversations between students and the administration team',
    },
  };

  const subject = SUBJECTS_THEME.find((s) => s.id === activeKey);
  if (subject) {
    return {
      title: `${subject.label} Content`,
      subtitle: 'Add modules and lectures with descriptions and example images',
    };
  }

  return map[activeKey] || map.dashboard;
}
